import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { Deck, DeckChanges, UpdateDeckRequest, UpdateDeckResponse } from "@apiserver-rest/ponder-data-client-base";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { take } from "rxjs";

@Component({
    selector: "deck-favorite",
    imports: [NgClass],
    templateUrl: "./deck-favorite.component.html"
})
export class DeckFavoriteComponent {
    @Input({ required: true }) public deck!: Deck;
    
    public readonly starSvgIcon: string = SvgIconMap.get(SvgIcon.Star)!;

    public constructor(private ponderDataClient: PonderDataClient) {

    }

    public onDeckFavoriteClicked(): void {
        const value = (this.deck.isFavorited ? false : true);
        const request = new UpdateDeckRequest({
            deckId: this.deck.id,
            deckChanges: new DeckChanges({
                isFavorited: value
            })
        });

        this.deck.isFavorited = value;

        this.ponderDataClient
            .deckUpdate(request)
            .pipe(take(1))
            .subscribe({
                next: (response: UpdateDeckResponse) => {
                    if (!response.success) {
                        this.deck.isFavorited = false;
                    }
                },
                error: () => {
                    this.deck.isFavorited = false;
                }
            });
    }
}